import { Box, Stack, Tab } from '@mui/material';
import { styled } from '@mui/system';
import { useState } from 'react';
import { useLocales } from 'src/locales';
import { CPTabs } from '../base/CPTabs';
import { ImagePresets } from './ImagePresets';
import { ImageUpload } from './ImageUpload';

type Props = {
  categories: { title: string; valueName: string }[];
  handleImageSelect: (value: string, type: 'color' | 'custom') => void;
};

export const ImagePickerUpload = ({ categories, handleImageSelect }: Props) => {
  const [currentTab, setCurrentTab] = useState<string>('presets');
  const { translate } = useLocales();

  const tabs = [
    {
      label: translate('shared.labels.presets'),
      value: 'presets',
      component: ImagePresets,
    },
    {
      label: translate('shared.labels.upload_image'),
      value: 'upload',
      component: ImageUpload,
    },
  ];

  return (
    <>
      <StyledCPTabs
        value={currentTab}
        onChange={(event, newValue) => setCurrentTab(newValue)}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            value={tab.value}
            label={tab.label}
            sx={{ margin: '0 10px' }}
          />
        ))}
      </StyledCPTabs>

      <StyledTabStack>
        {tabs.map(
          (tab) =>
            tab.value === currentTab && (
              <Box key={tab.value}>
                <tab.component
                  key={tab.value}
                  categories={categories}
                  handleImageSelect={handleImageSelect}
                />
              </Box>
            ),
        )}
      </StyledTabStack>
    </>
  );
};

const StyledCPTabs = styled(CPTabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(0, 3),
}));

const StyledTabStack = styled(Stack)(({ theme }) => ({
  maxHeight: 600,
  minHeight: 100,
  overflowY: 'auto',
  [theme.breakpoints.up('sm')]: {
    width: 400,
  },
}));
